import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import logo from "@/assets/logo.webp";
import { useAuth } from "@/lib/auth-context";

const SESSION_KEY = "app-splash-shown";
const MAX_DURATION = 4000;

export default function AppSplash() {
  const { loading } = useAuth();
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem(SESSION_KEY) !== "1";
  });

  useEffect(() => {
    if (!visible) return;
    const hide = () => {
      sessionStorage.setItem(SESSION_KEY, "1");
      setVisible(false);
    };
    const maxTimer = window.setTimeout(hide, MAX_DURATION);
    let minTimer: number | undefined;
    if (!loading) {
      minTimer = window.setTimeout(hide, 500);
    }
    return () => {
      window.clearTimeout(maxTimer);
      if (minTimer) window.clearTimeout(minTimer);
    };
  }, [loading, visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center gap-6 bg-background">
      <img src={logo} alt="LPUfootballshirts" className="h-20 w-auto" />
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
